<div class="file-explorer"> <!-- [ngStyle]="calcPositionStyle()" -->
  <div class="inner-wrap">
    <div class="top-bar">
      <div class="inner-wrap top-expl-wrap">
        <div class="title">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
            <path fill="#1A80B6" fill-rule="evenodd"
              d="M10.2 6.334L8.325 8.748l-1.336-1.61-1.875 2.407h7.5L10.2 6.335zM1.364 2.727H0v10.91C0 14.386.614 15 1.364 15h10.909v-1.364H1.363V2.727zM13.636 0H4.091c-.75 0-1.364.614-1.364 1.364v9.545c0 .75.614 1.364 1.364 1.364h9.545c.75 0 1.364-.614 1.364-1.364V1.364C15 .614 14.386 0 13.636 0zm0 10.91H4.091V1.363h9.545v9.545z" />
            </svg>

            <h4>{{translationsService.translate('FileExplorer_Header')}}</h4>
          </div>

          <div class="preview-cmds">
            <ul>
              <!--<li *ngIf="getPreviewType()=='image'">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15">
                <path fill="#1A80B6" fill-rule="evenodd"
                  d="M2.58 6.272L1.545 5.228a5.825 5.825 0 0 0-1.198 2.86H1.83c.103-.64.36-1.264.75-1.816zM1.83 9.56H.347a5.813 5.813 0 0 0 1.19 2.86l1.038-1.044a4.408 4.408 0 0 1-.743-1.816zm.744 3.912a5.826 5.826 0 0 0 2.867 1.183v-1.492a4.348 4.348 0 0 1-1.809-.758l-1.058 1.067zM6.912 2.993V.735L3.566 4.081l3.346 3.272V4.478a4.41 4.41 0 0 1 3.676 4.346 4.41 4.41 0 0 1-3.676 4.345v1.485a5.874 5.874 0 0 0 5.147-5.83c0-3-2.243-5.471-5.147-5.831z" />
                </svg>
              </li>

              <li *ngIf="getPreviewType()=='image'">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15">
                  <path fill="#1A80B6" fill-rule="evenodd"
                    d="M8.787 4.08L5.44.736v2.258a5.88 5.88 0 0 0-5.147 5.83c0 3 2.243 5.471 5.147 5.831V13.17a4.41 4.41 0 0 1-3.676-4.345A4.41 4.41 0 0 1 5.44 4.478v2.875L8.787 4.08zm3.22 4.008a5.813 5.813 0 0 0-1.19-2.86L9.771 6.272a4.27 4.27 0 0 1 .75 1.816h1.485zm-5.095 5.074v1.485a5.826 5.826 0 0 0 2.867-1.184l-1.058-1.059a4.254 4.254 0 0 1-1.81.758zm2.86-1.78l1.044 1.037a5.813 5.813 0 0 0 1.191-2.86h-1.485a4.336 4.336 0 0 1-.75 1.823z" />
                  </svg>
                </li>

                <li *ngIf="getPreviewType()=='image'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                    <path fill="#1A80B6" fill-rule="evenodd"
                      d="M.375 1.625v2.5h1.25v-2.5h2.5V.375h-2.5c-.688 0-1.25.563-1.25 1.25zm1.25 6.25H.375v2.5c0 .688.563 1.25 1.25 1.25h2.5v-1.25h-2.5v-2.5zm8.75 2.5h-2.5v1.25h2.5c.688 0 1.25-.563 1.25-1.25v-2.5h-1.25v2.5zm0-10h-2.5v1.25h2.5v2.5h1.25v-2.5c0-.688-.563-1.25-1.25-1.25z" />
                    </svg>
                  </li>

                  <li *ngIf="getPreviewType()=='image'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                      <path fill="#1A80B6" fill-rule="evenodd"
                        d="M10.625 9.375h1.25v-5c0-.688-.563-1.25-1.25-1.25h-5v1.25h5v5zm-6.25 1.25v-10h-1.25v2.5h-2.5v1.25h2.5v6.25c0 .688.563 1.25 1.25 1.25h6.25v2.5h1.25v-2.5h2.5v-1.25h-10z" />
                      </svg>
                    </li>-->

                    <li class="cmd-search">
                      <input type="text" [placeholder]="translationsService.translate('FileExplorer_Search')"
                        [(ngModel)]="searchText" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                          <path fill="#1A80B6" fill-rule="evenodd"
                            d="M7.547 8.576v-.542l-.185-.192A4.44 4.44 0 0 1 4.46 8.92a4.46 4.46 0 1 1 4.46-4.46 4.44 4.44 0 0 1-1.078 2.903l.192.185h.542L12 10.977 10.978 12l-3.43-3.424zm0-4.116A3.083 3.083 0 0 0 4.46 1.372 3.083 3.083 0 0 0 1.372 4.46 3.083 3.083 0 0 0 4.46 7.547 3.083 3.083 0 0 0 7.547 4.46z" />
                          </svg>
                        </li>
                      </ul>
                    </div>

                    <div class="explorer-window-cmds close-btn">
                      <!--svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" class="cmd-expand"
                      (click)="setExplorerNormalMax()" style="cursor: pointer;">
                      <path fill="#CCD2D5" fill-rule="evenodd"
                        d="M6.094 4.62l-.42-.42a.297.297 0 0 1 0-.42l2.07-2.069a.297.297 0 0 0 0-.419l-.3-.3a.296.296 0 0 1 .15-.5L9.937.006a.297.297 0 0 1 .35.35L9.802 2.7a.296.296 0 0 1-.5.15l-.3-.3a.297.297 0 0 0-.42 0L6.514 4.62a.297.297 0 0 1-.42 0zM.357 9.993a.296.296 0 0 1-.35-.35L.491 7.3a.296.296 0 0 1 .5-.15l.3.3a.296.296 0 0 0 .42 0L3.78 5.38a.297.297 0 0 1 .419 0l.419.42a.297.297 0 0 1 0 .42l-2.07 2.069a.297.297 0 0 0 0 .419l.3.3a.297.297 0 0 1-.149.5l-2.343.486z" />
                      </svg-->

                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" class="cmd-close"
                        (click)="dialogRef?.close()" style="cursor: pointer;">
                        <path fill="#CCD2D5" fill-rule="evenodd"
                          d="M5.326 3.76a.37.37 0 0 1-.522 0L1.152.109a.37.37 0 0 0-.522 0L.108.63a.369.369 0 0 0 0 .522l3.653 3.652a.37.37 0 0 1 0 .522L.238 8.848a.37.37 0 0 0 0 .522l.522.521a.37.37 0 0 0 .522 0L4.804 6.37a.37.37 0 0 1 .522 0l3.391 3.392a.37.37 0 0 0 .522 0l.522-.522a.37.37 0 0 0 0-.522L6.37 5.326a.37.37 0 0 1 0-.522l3.522-3.522a.37.37 0 0 0 0-.522L9.37.238a.369.369 0 0 0-.522 0L5.326 3.761z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="explorer-body">
                    <div class="file-list">

                      <div class="sec-title">
                        <p>{{translationsService.translate('FileExplorer_FileList')}}</p>

                        @if (type != 2 && type != 3) {
                          <div class="toggle-holder">
                            <div (click)="imgViewType = 1"
                              [ngStyle]="imgViewType == 1 ? {'background-image': 'url(../../../../assets/css/images/platform/img-icon@3x.png)'} : {'background-image': 'url(../../../../assets/css/images/platform/img-icon-gray@3x.png)'}">
                            </div>
                            <div class="div-separator"></div>
                            <div (click)="imgViewType = 0"
                              [ngStyle]="imgViewType == 0 ? {'background-image': 'url(../../../../assets/css/images/platform/list-icon@3x.png)'} : {'background-image': 'url(../../../../assets/css/images/platform/file-list-icon-gray@3x.png)'}">
                            </div>
                          </div>
                        }
                      </div>

                      @if (imgViewType == 0) {
                        <div>
                          @if (dfms?.isFormReadOnly == false) {
                            <svg class="add-file" xmlns="http://www.w3.org/2000/svg" width="17"
                              height="17" viewBox="0 0 17 17" (click)="onAddItemClick()">
                              <g fill="none" fill-rule="evenodd" stroke="#1A80B6" stroke-linecap="round" stroke-linejoin="round"
                                stroke-width=".7">
                                <path
                                  d="M3.167 3.167a7.4 7.4 0 1 1 10.466 10.466A7.4 7.4 0 0 1 3.167 3.167zM8.4 4.894v7.148M4.439 8.4h7.922" />
                                </g>
                              </svg>
                            }
                            <ul>
                              @for (f of files; track f) {
                                <li (click)="selectItem(f)"
                                  [ngClass]="{'selected': selectedItem!=null && f.Name == selectedItem.Name, 'search-notfound': searchCheckShow(f) == false }"
                                  [makeDraggable]="f" makeDroppable (dropped)="onDrop(f,$event)">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
                                    <path fill="#000" fill-rule="evenodd"
                                      d="M9.625 0h-8.25C.619 0 0 .619 0 1.375v8.25C0 10.381.619 11 1.375 11h8.25C10.381 11 11 10.381 11 9.625v-8.25C11 .619 10.381 0 9.625 0zm-.688 6.188H2.064V4.813h6.874v1.375zm-2.75 2.75H2.063V7.562h4.126v1.375zm2.75-5.5H2.064V2.062h6.874v1.376z"
                                      opacity=".246" />
                                    </svg>
                                    <p>
                                      {{f.Name}}
                                    </p>
                                  </li>
                                }
                              </ul>
                            </div>
                          }

                          @if (imgViewType == 1) {
                            <div class="thumb-wrapper">
                              <ng-scrollbar [visibility]="'hover'">
                                @for (f of shownFiles; track f) {
                                  <div (click)="setSelected(f.name)" class="preview-holder"
                                    [ngClass]="{'selected': selectedItem!=null && f.name == selectedItem.Name, 'search-notfound': searchCheckShow(f) == false }">
                                    <div class="img-list-item" [ngStyle]="{'background-image': 'url(' + f.path + ')'}"></div>
                                    <p>{{f.name}}</p>
                                  </div>
                                }
                              </ng-scrollbar>
                            </div>
                          }

                        </div>
                        <div class="file-preview">
                          <div class="preview-wrap">

                            <sem-loader [showLoader]="loading"></sem-loader>

                            @if (getPreviewType()=='image') {
                              <img id="annotate" [src]="selectedImageData" />
                            }

                            <!--div id="annotate" class="pr-image" *ngIf="getPreviewType()=='image'"
                            [ngStyle]="{'background-image': 'url(' + selectedImageDataString + ')'}">
                          </div-->

                          @if (getPreviewType()=='text') {
                            <textarea class="pr-text">
                              {{txtFileContent}}
                            </textarea>
                          }

                          @if (getPreviewType()=='pdf') {
                            <div>
                              <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="file-info">
                        @if (type != 2 && type != 3) {
                          <div class="sec-title-btns">
                            <button [ngClass]="{'selected-btn': sideType === 0}" (click)="sideType = 0">
                              Slika
                            </button>
                            @if (type != 2) {
                              <button [ngClass]="{'selected-btn': sideType === 1}" (click)="sideType = 1">
                                Oznake
                              </button>
                            }
                          </div>
                        }
                        @if (type == 2 || type == 3) {
                          <div class="sec-title-btns one-btn">
                            <button [ngClass]="{'selected-btn': sideType === 0}" (click)="sideType = 0">
                              {{this.translationsService.translate('File')}}
                            </button>
                          </div>
                        }
                        @if (selectedItem != null && sideType == 0) {
                          <div class="file-details">
                            <ul>
                              <li>
                                <label (click)="downloadSelectedFile(selectedItem)"
                                class="download-file-label">{{translationsService.translate('FileExplorer_Download')}}</label>
                              </li>
                              <li>
                                <label>{{translationsService.translate('FileExplorer_Title')}}</label>
                                <input type="text" [disabled]="readOnlyFields" [(ngModel)]="selectedItem.Title" />
                              </li>
                              <li>
                                <label>{{translationsService.translate('FileExplorer_Description')}}</label>
                                <input type="text" [disabled]="readOnlyFields" [(ngModel)]="selectedItem.Description" />
                              </li>
                              <li>
                                <label>{{translationsService.translate('FileExplorer_Category')}}</label>
                                <input type="text" [disabled]="readOnlyFields" [(ngModel)]="selectedItem.Category" />
                              </li>
                              <li>
                                <label>{{translationsService.translate('FileExplorer_FileSize')}}</label>
                                <div class="input-notedit">{{getFrendlyFileSize(selectedItem.File.size)}}</div>
                              </li>
                              <li>
                                <label>{{translationsService.translate('FileExplorer_FileType')}}</label>
                                <div class="input-notedit">{{getExtension(selectedItem.Name)}}</div>
                              </li>
                            </ul>
                          </div>
                        }

                        @if (sideType == 1) {
                          <div class="annotations-view">
                            @if (annotations.length > 0) {
                              <p class="no-marks">Oznake</p>
                            }
                            @for (ann of annotations; track ann) {
                              <div>
                                <div class="input-notedit">
                                  {{getAnnotationBody(ann)}}
                                </div>
                              </div>
                            }
                            @if (annotations.length == 0) {
                              <div>
                                <p class="no-marks">Slika še nima oznak</p>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="bottom-bar">
                    <div class="drag-info">
                      <span>{{translationsService.translate('FileExplorer_SortInAnyOrder')}}</span>
                    </div>
                    <div class="file-cmds">

                      <!--div class="add-file">
                      <img height="17px" width="17px" src="../../../../assets/css/images/platform/ikona-table-add@3x.png"
                        (click)="onStartAnnotate()" />
                      </div>
                      <div class="man-file">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" (click)="onDownload()" *ngIf="dfms?.isFormReadOnly == false">
                          <g fill="#1A80B6" fill-rule="evenodd">
                            <path
                              d="M10.602 11.396a.326.326 0 0 0-.46 0l-2.385 2.385V4.085a.326.326 0 0 0-.65 0v9.696l-2.385-2.385a.326.326 0 0 0-.46.46l2.94 2.94a.325.325 0 0 0 .46 0l2.94-2.94a.326.326 0 0 0 0-.46" />
                              <path
                                d="M11.618 10.271H9.633a.325.325 0 0 1 0-.65h1.985a2.598 2.598 0 0 0 2.595-2.595 2.598 2.598 0 0 0-2.595-2.595h-.595a.325.325 0 0 1-.325-.342l.003-.067c.003-.035.005-.068.005-.097A3.278 3.278 0 0 0 7.432.651a3.278 3.278 0 0 0-3.275 3.274c0 .03.003.062.005.097l.004.067a.325.325 0 0 1-.325.342h-.595A2.598 2.598 0 0 0 .65 7.026 2.597 2.597 0 0 0 3.246 9.62H5.23a.326.326 0 0 1 0 .651H3.246A3.25 3.25 0 0 1 0 7.026 3.25 3.25 0 0 1 3.246 3.78h.263A3.93 3.93 0 0 1 7.432 0a3.93 3.93 0 0 1 3.922 3.78h.264a3.25 3.25 0 0 1 3.245 3.246 3.25 3.25 0 0 1-3.245 3.245" />
                              </g>
                            </svg>
                            <div *ngIf="selectedItem!=null && selectedItem.ReadOnly == false && dfms?.isFormReadOnly == false" class="div-separator"></div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" (click)="onDelete()"
                              *ngIf="selectedItem!=null && selectedItem.ReadOnly == false && dfms?.isFormReadOnly == false">
                              <g fill="#1A80B6" fill-rule="evenodd">
                                <path
                                  d="M6.12 11.675a.325.325 0 0 1-.326-.325V4.98a.325.325 0 0 1 .651 0v6.37c0 .18-.146.325-.325.325zm2.145 0a.325.325 0 0 1-.325-.325V4.98a.325.325 0 0 1 .65 0v6.37c0 .18-.145.325-.325.325zm-4.29 0a.325.325 0 0 1-.326-.325V4.98a.325.325 0 0 1 .65 0v6.37c0 .18-.145.325-.324.325z" />
                                  <path
                                    d="M9.569 14.241H2.67L1.75 2.15h8.742L9.57 14.24zM4.47.929c0-.153.122-.278.271-.278H7.5c.149 0 .27.125.27.278v.57H4.47v-.57zm7.444.57H8.42v-.57a.927.927 0 0 0-.921-.93H4.74a.927.927 0 0 0-.922.93v.57H.325a.325.325 0 0 0 0 .65h.77l.95 12.442c.013.17.154.301.324.301H9.87c.17 0 .312-.131.325-.3l.949-12.443h.77a.325.325 0 0 0 0-.65z" />
                                  </g>
                                </svg>
                              </div-->

                              <!--ul>
                              <li (click)="onDownload()" *ngIf="dfms?.isFormReadOnly == false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                  <g fill="#1A80B6" fill-rule="evenodd">
                                    <path
                                      d="M10.602 11.396a.326.326 0 0 0-.46 0l-2.385 2.385V4.085a.326.326 0 0 0-.65 0v9.696l-2.385-2.385a.326.326 0 0 0-.46.46l2.94 2.94a.325.325 0 0 0 .46 0l2.94-2.94a.326.326 0 0 0 0-.46" />
                                      <path
                                        d="M11.618 10.271H9.633a.325.325 0 0 1 0-.65h1.985a2.598 2.598 0 0 0 2.595-2.595 2.598 2.598 0 0 0-2.595-2.595h-.595a.325.325 0 0 1-.325-.342l.003-.067c.003-.035.005-.068.005-.097A3.278 3.278 0 0 0 7.432.651a3.278 3.278 0 0 0-3.275 3.274c0 .03.003.062.005.097l.004.067a.325.325 0 0 1-.325.342h-.595A2.598 2.598 0 0 0 .65 7.026 2.597 2.597 0 0 0 3.246 9.62H5.23a.326.326 0 0 1 0 .651H3.246A3.25 3.25 0 0 1 0 7.026 3.25 3.25 0 0 1 3.246 3.78h.263A3.93 3.93 0 0 1 7.432 0a3.93 3.93 0 0 1 3.922 3.78h.264a3.25 3.25 0 0 1 3.245 3.246 3.25 3.25 0 0 1-3.245 3.245" />
                                      </g>
                                    </svg>

                                  </li>

                                  <li (click)="onDelete()"
                                    *ngIf="selectedItem!=null && selectedItem.ReadOnly == false && dfms?.isFormReadOnly == false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15">
                                      <g fill="#1A80B6" fill-rule="evenodd">
                                        <path
                                          d="M6.12 11.675a.325.325 0 0 1-.326-.325V4.98a.325.325 0 0 1 .651 0v6.37c0 .18-.146.325-.325.325zm2.145 0a.325.325 0 0 1-.325-.325V4.98a.325.325 0 0 1 .65 0v6.37c0 .18-.145.325-.325.325zm-4.29 0a.325.325 0 0 1-.326-.325V4.98a.325.325 0 0 1 .65 0v6.37c0 .18-.145.325-.324.325z" />
                                          <path
                                            d="M9.569 14.241H2.67L1.75 2.15h8.742L9.57 14.24zM4.47.929c0-.153.122-.278.271-.278H7.5c.149 0 .27.125.27.278v.57H4.47v-.57zm7.444.57H8.42v-.57a.927.927 0 0 0-.921-.93H4.74a.927.927 0 0 0-.922.93v.57H.325a.325.325 0 0 0 0 .65h.77l.95 12.442c.013.17.154.301.324.301H9.87c.17 0 .312-.131.325-.3l.949-12.443h.77a.325.325 0 0 0 0-.65z" />
                                          </g>
                                        </svg>
                                      </li>

                                      <li (click)="onStartAnnotate()" *ngIf="dfms?.isFormReadOnly == false">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                          <g fill="#1A80B6" fill-rule="evenodd">
                                            <path
                                              d="M10.602 11.396a.326.326 0 0 0-.46 0l-2.385 2.385V4.085a.326.326 0 0 0-.65 0v9.696l-2.385-2.385a.326.326 0 0 0-.46.46l2.94 2.94a.325.325 0 0 0 .46 0l2.94-2.94a.326.326 0 0 0 0-.46" />
                                              <path
                                                d="M11.618 10.271H9.633a.325.325 0 0 1 0-.65h1.985a2.598 2.598 0 0 0 2.595-2.595 2.598 2.598 0 0 0-2.595-2.595h-.595a.325.325 0 0 1-.325-.342l.003-.067c.003-.035.005-.068.005-.097A3.278 3.278 0 0 0 7.432.651a3.278 3.278 0 0 0-3.275 3.274c0 .03.003.062.005.097l.004.067a.325.325 0 0 1-.325.342h-.595A2.598 2.598 0 0 0 .65 7.026 2.597 2.597 0 0 0 3.246 9.62H5.23a.326.326 0 0 1 0 .651H3.246A3.25 3.25 0 0 1 0 7.026 3.25 3.25 0 0 1 3.246 3.78h.263A3.93 3.93 0 0 1 7.432 0a3.93 3.93 0 0 1 3.922 3.78h.264a3.25 3.25 0 0 1 3.245 3.246 3.25 3.25 0 0 1-3.245 3.245" />
                                              </g>
                                            </svg>

                                          </li>
                                        </ul-->
                                      </div>
                                      <div class="submit-cmds">
                                        <button style="display:none;"
                                        class="save">{{translationsService.translate('galis_js_SearchForm_SaveButton')}}</button>
                                        <button style="display:none;" class="cancel">{{translationsService.translate('Decline')}}</button>
                                      </div>
                                    </div>
                                  </div>